// extracted by mini-css-extract-plugin
export default {"imageWrapper":"wE-z","hovered":"xE-z","hoverImage":"yE-z","mainImage":"zE-z","imageNoBackground":"AE-z","fullSizeImage":"BE-z"};